import { api } from "../api/api";
import { ISelectOption } from "../constants/types";
import { IBranchOffice } from "../redux/branchOffice/branchOffice.types";
import { IInsurerCode } from "../redux/insurer/insurer.types";

export const getInsurerNameByCode = async (code: string | null) => {
  if (code) {
    const res = await api.get(
      `/insurance/get-insurer-code?column=insurer_code&column=name&value=${code}`
    );
    const data: IInsurerCode[] = res.data.data;
    const finalData: ISelectOption[] = [];
    for (const insurer of data) {
      if (insurer.insurer_code) {
        finalData.push({
          label: insurer.name,
          value: insurer.name,
        });
      }
    }

    if (finalData.length > 0) {
      return finalData[0].label;
    }
  }

  return "";
};

export const getBranchNamebyCode = async (code: string | null) => {
  if (code) {
    const res = await api.get(
      `/insurance/get-branch-office?column=name&column=branch_code&value=${code}`
    );
    const data: IBranchOffice[] = res.data.data;
    const finalData: ISelectOption[] = [];
    for (const branchOffice of data) {
      if (branchOffice.branch_code) {
        finalData.push({
          label: `${branchOffice.name}`,
          value: branchOffice.name,
        });
      }

      if (finalData.length > 0) {
        return finalData[0].label;
      }
    }
  }

  return "";
};

export const getInsurerDataByCode = async (code: string | null) => {
  if (code) {
    const res = await api.get(
      `/insurance/get-insurer-code?insurer_code=${code}`
    );
    const data: IInsurerCode[] = res.data.data;

    if (data.length > 0) {
      return data[0];
    }
  }

  return "";
};

export const getBranchDataByCode = async (code: string | null) => {
  if (code) {
    const res = await api.get(
      `/insurance/get-branch-office?column=branch_code&value=${code}&status=ACTIVE`
    );
    const data: IBranchOffice[] = res.data.data;
    if (data.length > 0) {
      return data[0];
    }
  }
};
